const useInputModifiers = () => {
    const zipcode = (value) => value ? value.replace(/\s*(\d{4})\s*([A-Za-z]{2})\s*/, "$1 $2") : value;

    return {
        zipcode
    }
}

export default useInputModifiers;